import { isRejectedWithValue } from '@reduxjs/toolkit'

import { setError } from 'store/reducers-common/Auth/slice.ts'

import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit'

export const errorLogger: Middleware = (_api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const { status } = action.payload

    if (status === 401) {
      _api.dispatch(
        setError({
          code: status,
        }),
      )

      // todo show sign modal?
    }
  }

  return next(action)
}
